document.addEventListener("DOMContentLoaded", function() {
    if (!!document.querySelector("#atc-bundle-v2") === true){
        var atcBtn = document.querySelector("#atc-bundle-v2");
    } else if (!!document.querySelector("#productMainSubmit") === true){
        var atcBtn = document.querySelector("#productMainSubmit");
    }

    if (atcBtn){

        window.addEventListener('scroll', function() {
            var btnPosition = atcBtn.getBoundingClientRect().top;
            if (btnPosition < 0) {
                document.querySelector(".sticky-atc").style.cssText = "bottom: 0px;";
            } else {
                document.querySelector(".sticky-atc").style.cssText = "bottom: -200px;";
            }
        });

        document.querySelector(".sticky-atc .button-sticky-atc").onclick = function() {
            atcBtn.scrollIntoView({ 
                behavior: 'smooth',
                block: 'center'
            });
            atcBtn.click();
        };

        if (!!document.querySelector('.bundle-products__list-product.active .compare-price') === true){
            if (!!document.querySelector('.bundle-products__list-product-2>span:not(.economisez):only-child') === true){
                document.querySelector(".sticky-atc .sticky-atc-title").textContent = document.querySelector(".bundle-products__list-product.active .bundle-products__list-product-2 span").textContent;
            } else {
                document.querySelector(".sticky-atc .sticky-atc-title").textContent = document.querySelector(".bundle-products__list-product.active .bundle-products__list-product-title>span").textContent;
            }
            document.querySelector(".sticky-atc .sticky-atc-price").textContent = document.querySelector('.bundle-products__list-product.active .compare-price').textContent;

            var bundleProducts = document.querySelectorAll('.bundle-products .bundle-products__list .bundle-products__list-product');
            for (var i = 0; i < bundleProducts.length; i++) {
                bundleProducts[i].addEventListener('click', function(event) {
                    if (!!document.querySelector('.bundle-products__list-product-2>span:not(.economisez):only-child') === true){
                        document.querySelector(".sticky-atc .sticky-atc-title").textContent = event.currentTarget.querySelector(".bundle-products__list-product-2 span").textContent;
                    } else {
                        document.querySelector(".sticky-atc .sticky-atc-title").textContent = event.currentTarget.querySelector(".bundle-products__list-product-title>span").textContent;
                    }
                    document.querySelector(".sticky-atc .sticky-atc-price").textContent = event.currentTarget.querySelector('.compare-price').textContent;
                });
            }

        } else {
            document.querySelector(".sticky-atc .sticky-atc-price").textContent = document.querySelector("#productMainSubmit .price.price--on-sale .price-item--sale").textContent;
        }
    }

  const MOBILE_SRC = "https://cdn.shopify.com/s/files/1/0756/0236/2703/files/banner-right-mobile.png";
  const SELECTOR = 'html .custom-content.hero:has(.hero-frequence) .custom-w-50 img[src*="banner-right.png"]';

  function swapImage(img) {
    if (window.innerWidth < 768) {
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.getAttribute("src");
        img.dataset.originalSrcset = img.getAttribute("srcset") || "";
        img.dataset.originalSizes = img.getAttribute("sizes") || "";
      }
      img.setAttribute("src", MOBILE_SRC);
      img.setAttribute("srcset", MOBILE_SRC);
      img.removeAttribute("sizes");
    } else {
      if (img.dataset.originalSrc) {
        img.setAttribute("src", img.dataset.originalSrc);
        img.setAttribute("srcset", img.dataset.originalSrcset);
        img.setAttribute("sizes", img.dataset.originalSizes);
      }
    }
  }

  function run() {
    const img = document.querySelector(SELECTOR);
    if (img) swapImage(img);
  }

  // Initial run
  run();

  // On resize
  window.addEventListener("resize", run);

  // Observer si l'image est chargée dynamiquement
  const observer = new MutationObserver(run);
  observer.observe(document.body, { childList: true, subtree: true });







  if (window.innerWidth > 768) return;

  const grid = document.querySelector('.routine-experte .routine-grid');
  if (!grid) return;

  const colTitles = grid.querySelectorAll('.routine-header .col-title');
  const rows = grid.querySelectorAll('.routine-row');
  const benefice = grid.querySelector('.routine-benefice');
  const separators = grid.querySelectorAll('.routine-separator');

  function setActiveTab(index) {
    colTitles.forEach((t, i) => t.classList.toggle('active', i === index));

    rows.forEach(row => {
      const cards = row.querySelectorAll('.product-card');
      cards.forEach((card, i) => card.classList.toggle('tab-visible', i === index));
    });

    if (benefice) {
      const items = benefice.querySelectorAll('.benefice-item');
      items.forEach((item, i) => item.classList.toggle('tab-visible', i === index));
    }

    separators.forEach(sep => {
      const lines = sep.querySelectorAll('.line');
      lines.forEach((line, i) => line.classList.toggle('tab-visible', i === index));
    });
  }

  setActiveTab(0);

  colTitles.forEach((title, i) => {
    title.addEventListener('click', () => setActiveTab(i));
  });



  var section = document.querySelector('[id*="custom_content_RPQYJN"]');
  if (!section) return;

  var container = section.querySelector('.custom-content .custom-content-list');
  if (!container) return;

  var img = document.createElement('img');
  img.src = 'https://cdn.shopify.com/s/files/1/0756/0236/2703/files/IMG_0760_1_copy_2.jpg';
  img.className = 'img-mobile-only';
  container.insertBefore(img, container.firstChild);

  var style = document.createElement('style');
  style.textContent = '.img-mobile-only { display: none; width: 100%; } @media (max-width: 767px) { .img-mobile-only { display: block; } }';
  document.head.appendChild(style);

});